export default __webpack_public_path__ + "static/media/hamburger.b7a3b09f.svg";